import React from 'react'
import { OrderList } from 'primereact/orderlist';
import { EncoderObject } from '../Types/AllTypes';

type Props = {
  selectedAlgorithms: EncoderObject[];
  setSelectedAlgorithms: (inputs: EncoderObject[]) => void;
}

const SelectedAlgorithmsDisplay = ({ selectedAlgorithms, setSelectedAlgorithms }: Props) => {
  const itemTemplate = (item: EncoderObject) => {
    return (
      <div className='selectedAlgorithmItems'>
        <i className='pi pi-bars'></i>
        {item.name}
      </div>
    );
  };

  return (
    <div>
      <OrderList dataKey="code" value={selectedAlgorithms} onChange={(e) => setSelectedAlgorithms(e.value)}
        itemTemplate={itemTemplate}
        header="Selected Algorithms"
        dragdrop
        listStyle={{ maxHeight: '13rem' }}
      >

      </OrderList>
    </div >
  )
}

export default SelectedAlgorithmsDisplay